import React from 'react';
import { Div, DivProps } from '@kizi/core-components';

export interface CountbarProps extends DivProps {
  value: string | number;
  maxAmount?: number;
  valueToPrefill?: string | number;
}

export const Countbar: React.FC<CountbarProps> = ({
  value,
  maxAmount = 6,
  valueToPrefill = 0,
  ...containerProps
}) => {
  let digits = value.toString().split('');
  if (digits.length < maxAmount) {
    digits = [
      ...new Array(maxAmount - digits.length).fill(valueToPrefill),
      ...digits,
    ];
  }

  return (
    <Div variant="countbar" {...containerProps}>
      {digits.map((item, index) => (
        <Div key={index}>{item}</Div>
      ))}
    </Div>
  );
};
